import { Component, HostBinding } from '@angular/core';

/**
 * @ngdoc component
 * @name ApValueComponent
 * @deprecated In favor of plain CSS `dl.ap-definition-list>dt+dd`
 */
@Component({
    selector: 'dd',
    templateUrl: './value.component.html'
})
export class ApValueComponent {
    @HostBinding('class.keys-values__value') public hostClass = true;
}
